/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICittaWholesaleNewsletterFormViewProps } from './citta-wholesale-newsletter-form';

/**
 *
 * ICittaProductSkuView component
 * @extends {React.PureComponent<ICittaProductSkuViewProps>}
 */
export class ICittaWholesaleNewsletterFormView extends React.PureComponent<ICittaWholesaleNewsletterFormViewProps> {

    public render(): JSX.Element | null {
        const {
          WholesaleWrapper,
          wholesaleResponse,
          wholesaleForm,
          responseSuccess,
          formErrors,
          formErrorsNodeProps,
          successResponseNodeProps,
          showSuccessResponse,
          successResponse,
          isUnsubscribe
        } = this.props;

        const {
          FormWrapper,
          FormContainer,
          firstAndLastNameInput,
          emailInput,
          businessNameInput,
          lineOfBusinessInput,
          cityInput,
          wholesaleOptIn,
          cdpOptIn,
          field1OptIn,
          checkboxPrivacyPolicy,
          wholesaleButtton,
          reCaptcha,
          subscribeThanks
          
        } = wholesaleForm;

        if (isUnsubscribe) {
            return (
                <Module {...WholesaleWrapper} >
                    {wholesaleResponse}
                    {showSuccessResponse ?
                        <Node {...successResponseNodeProps}>
                            {'update successful'}
                        </Node>
                        : <Node {...FormWrapper} >
                            <Node {...FormContainer} >
                                {emailInput}
                                {wholesaleOptIn}
                                {cdpOptIn}
                                {field1OptIn}
                                {checkboxPrivacyPolicy}
                                {reCaptcha}
                                {responseSuccess ? subscribeThanks : wholesaleButtton}
                            </Node>
                            <Node {...formErrorsNodeProps}>
                                {formErrors}
                            </Node>
                        </Node>
                    }
                </Module>
            );
        }

        return (
            <Module {...WholesaleWrapper} >
                {wholesaleResponse}
                {showSuccessResponse ?
                    <Node {...successResponseNodeProps}>
                        {successResponse}
                    </Node>
                    : <Node {...FormWrapper} >
                        <Node {...FormContainer} >
                            {firstAndLastNameInput}
                            {emailInput}
                            {businessNameInput}
                            {lineOfBusinessInput}
                            {cityInput}
                            {wholesaleOptIn}
                            {cdpOptIn}
                            {field1OptIn}
                            {checkboxPrivacyPolicy}
                            {reCaptcha}
                            {responseSuccess ? subscribeThanks : wholesaleButtton}
                        </Node>
                        <Node {...formErrorsNodeProps}>
                            {formErrors}
                        </Node>
                    </Node>
                }
            </Module>
        );
    }
}
export default ICittaWholesaleNewsletterFormView;
